export const ENTITY_WIDTH = 4;
export const START_DELAY = 60;